import { List } from "immutable";

import { notEmpty } from "./comparison";

export interface IPaginationData {
  page: number;
  perPage: number;
  totalPages: number;
  totalResults: number;
}

export interface IPaginationResponse<T> {
  pagination: IPaginationData;
  result: List<T>;
}

export type TQsFilter = { toQueryString: () => string };

interface IPaginationApiResponse {
  pagination: IPaginationData;
  result: Record<string, unknown>[];
}

type TFetchItems = () => Promise<{ data: IPaginationApiResponse | Record<string, unknown>[] }>;
type TItemParser<T> = (item: Record<string, unknown>, index: number) => null | T | undefined;

export async function withPagination<T>(
  itemParser: TItemParser<T>,
  fetchItems: TFetchItems,
): Promise<IPaginationResponse<T>> {
  const { data } = await fetchItems();

  if (isPaginationResponse(data)) {
    return {
      pagination: data.pagination,
      result: List(data.result.map(itemParser)).filter(notEmpty),
    };
  } else {
    return {
      pagination: {
        page: 1,
        perPage: data.length,
        totalPages: 1,
        totalResults: data.length,
      },
      result: List(data.map(itemParser).filter(notEmpty)),
    };
  }
}

function isPaginationResponse(
  responseData: IPaginationApiResponse | Record<string, unknown>[],
): responseData is IPaginationApiResponse {
  return !Array.isArray(responseData) && Object.keys(responseData).includes("pagination");
}
